import { useState, useEffect } from 'react';
import type { FutebolJogoDia } from '@/shared/types';
import { futebolRepository } from '../../data/futebolRepository';

export function useProximoJogo(enabled: boolean): FutebolJogoDia | null {
  const [proximo, setProximo] = useState<FutebolJogoDia | null>(null);

  useEffect(() => {
    if (!enabled) {
      setProximo(null);
      return;
    }
    let cancelado = false;
    futebolRepository.listarJogosDoDia()
      .then(jogos => {
        if (cancelado) return;
        const agoraMs = Date.now();
        setProximo(
          jogos.find(j => j.status === 'pendente' && new Date(j.horario).getTime() > agoraMs) ?? null,
        );
      })
      .catch(() => {
        if (!cancelado) setProximo(null);
      });
    return () => { cancelado = true; };
  }, [enabled]);

  return proximo;
}
